export default "__VITE_PUBLIC_ASSET__e0eb0179__"